import Visa from "../assets/visa.svg";
import Diners from "../assets/diners.svg";
import Discover from "../assets/discover.svg";
import Amex from "../assets/amex.svg";
import MasterCard from "../assets/mastercard.svg";
import GooglePay from "../assets/googlepay.svg";
import ACH from "../assets/ach.png";
import ApplePay from "../assets/applepay.svg";
import JCB from "../assets/jcb-card-icon.svg";
import EFTPOS_AUSTRALIA from "../assets/eftpos_australia.svg";
import CUP from "../assets/cup.svg";
import CreditCardIcon from "@heroicons/react/24/solid/CreditCardIcon";

type Props = {
  type: string;
};

function getSvg(type: string) {
  if (!type) return "";

  const lowercaseType = type.toLowerCase();
  if (lowercaseType.includes("applepay")) return ApplePay;
  if (lowercaseType.includes("google pay")) return GooglePay;
  if (lowercaseType === "visa") return Visa;
  if (lowercaseType === "diners") return Diners;
  if (lowercaseType === "mastercard" || lowercaseType === "mc")
    return MasterCard;
  if (lowercaseType === "discover") return Discover;
  if (lowercaseType.includes("american") || lowercaseType === "amex")
    return Amex;
  if (lowercaseType.includes("jcb")) return JCB;
  if (lowercaseType.includes("eftpos_australia")) return EFTPOS_AUSTRALIA;
  if (lowercaseType.includes("cup")) return CUP;
  if (lowercaseType.includes("ach")) return ACH;
  return "";
}

function getTitle(type: string) {
  if (type === "eft_directdebit_CA") return "EFTPAD";
  return type;
}

function PaymentIcon({ type }: Props): JSX.Element {
  const svg = getSvg(type);
  const title = getTitle(type);

  if (svg) {
    let classList = svg === ApplePay ? "h-4" : "h-4 rounded";
    return (
      <img src={getSvg(type)} alt={title} title={title} className={classList} />
    );
  }
  return (
    <div title={title}>
      <CreditCardIcon className="h-6 w-6" />
    </div>
  );
}

export default PaymentIcon;
